import React from 'react';

const waveStyle1 = {
    animation: 'waveUpDown1 4s ease-in-out infinite alternate'
};
  
const waveStyle2 = {
    animation: 'waveUpDown2 7s ease-in-out infinite alternate'
};
  
const waveStyle3 = {
    animation: 'waveUpDown3 5s ease-in-out infinite alternate'
};

const Hero = () => {
    return (
        <section id="home" className="relative bg-cover bg-center h-screen" style={{ backgroundImage: "url('/hero-bg.jpg')" }}>
            {/* Improved gradient overlay with multiple colors */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-900/85 via-blue-800/80 to-indigo-900/75"></div>

            {/* Decorative elements */}
            <div className="absolute inset-0 opacity-30">
                <div className="absolute top-20 left-10 w-24 h-24 rounded-full bg-blue-400 blur-3xl"></div>
                <div className="absolute bottom-20 right-10 w-32 h-32 rounded-full bg-indigo-400 blur-3xl"></div>
            </div>

            <div className="container mx-auto h-full flex flex-col justify-center items-center text-center text-white relative z-10 px-4">
                {/* Main heading with text shadow and responsive sizing */}
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-shadow-sm tracking-tight">
                    Welcome to <span className="text-blue-200">SeraphMed</span>
                </h1>

                <p className="mt-6 text-lg md:text-xl max-w-2xl text-blue-50 font-light">
                    Your trusted healthcare partner with AI-powered solutions for better diagnosis and treatment.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
                    <a
                        href="/register"
                        className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-8 rounded-full text-lg shadow-lg hover:shadow-blue-500/30 hover:scale-105 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-blue-800 transition-all duration-300 ease-in-out"
                    >
                        Book an Appointment
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </a>

                    <a
                        href="#services"
                        className="inline-flex items-center justify-center bg-transparent border-2 border-blue-300 text-blue-100 py-3 px-8 rounded-full text-lg hover:bg-blue-800/30 hover:border-blue-200 focus:ring-2 focus:ring-blue-400 transition-all duration-300 ease-in-out"
                    >
                        Our Services
                    </a>
                </div>

                {/* Trust indicators */}
                <div className="mt-16 flex flex-wrap justify-center items-center gap-6 text-sm text-blue-200/80">
                    <div className="flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                         AI Diagnostics
                    </div>
                    <div className="flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        24/7 Support
                    </div>
                </div>
            </div>

            {/* Flowing Water Wave Dividers - Now with up-down animation */}
          
        </section>
    );
};

export default Hero;